export default __webpack_public_path__ + "7189fbe65d0dcb47d421366815ce24db.svg";